





































import { Vue, Component, Prop } from 'vue-property-decorator';
import { omegaup } from '../../omegaup';
import CountryFlag from '../CountryFlag.vue';
import T from '../../lang';
import { getBlogUrl } from '../../urlHelper';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
library.add(faInfoCircle);

@Component({
  components: {
    FontAwesomeIcon,
    'omegaup-countryflag': CountryFlag,
  },
})
export default class SchoolOfTheMonth extends Vue {
  @Prop() schoolOfTheMonth!: omegaup.SchoolOfTheMonth;

  T = T;

  get NewSchoolofTheMonthFeatureURL(): string {
    return getBlogUrl('NewSchoolofTheMonthFeatureURL');
  }
}
